import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import './privacypolicy.css'
import { useEffect } from "react";

export default function PrivacyPolicy({}){

    const navigate = useNavigate();

    useEffect(() => {
        const verified = localStorage.getItem("verificado");
        const auth = localStorage.getItem("auth");
        if(auth === "true"){
            if(verified === "false"){
                navigate('/EmailVerify')
            }
        }
    }, []);

    return(
        <div>
            <Header></Header>
            <div className="privacypolicy-container">
                <div className="privacypolicy-content">
                    <h1>Política de Privacidade - Me localizaÊ</h1>

                    <p><strong>Última atualização:</strong> 18/12/2025</p>

                    <p>
                    A Me localizaÊ valoriza a sua privacidade e está comprometida com a proteção dos dados pessoais de seus usuários. 
                    Esta Política de Privacidade explica, de forma clara e transparente, como coletamos, utilizamos, armazenamos e protegemos 
                    suas informações durante o uso da nossa plataforma, especialmente no momento de cadastro.
                    </p>

                    <p>
                    Ao realizar o cadastro ou utilizar os serviços da Me localizaÊ, você concorda com os termos desta Política.
                    </p>

                    <h2>1. Quem somos</h2>

                    <p>
                    A <strong>Me localizaÊ</strong> é uma plataforma que auxilia pessoas a encontrarem o bairro ideal para morar, 
                    oferecendo informações confiáveis sobre segurança, mobilidade, infraestrutura e outros aspectos relevantes 
                    para a tomada de decisão.
                    </p>

                    <h2>2. Quais dados coletamos</h2>

                    <h3>2.1. Dados fornecidos pelo usuário</h3>

                    <p>Nome completo</p>
                    <p>Endereço de e-mail</p>
                    <p>Telefone (quando aplicável)</p>
                    <p>Cidade ou região de interesse</p>
                    <p>Informações fornecidas voluntariamente em formulários, pesquisas ou contato</p>

                    <h3>2.2. Dados coletados automaticamente</h3>

                    <p>Endereço IP</p>
                    <p>Tipo de dispositivo e navegador</p>
                    <p>Dados de acesso e navegação na plataforma</p>
                    <p>Cookies e tecnologias semelhantes</p>

                    <h2>3. Finalidade do uso dos dados</h2>

                    <p>Realizar o cadastro e autenticação do usuário</p>
                    <p>Oferecer relatórios, conteúdos e funcionalidades da plataforma</p>
                    <p>Melhorar a experiência do usuário e aprimorar nossos serviços</p>
                    <p>Enviar comunicações sobre atualizações, lançamentos e novidades (quando autorizado)</p>
                    <p>Cumprir obrigações legais e regulatórias</p>

                    <h2>4. Compartilhamento de dados</h2>

                    <p>
                    A Me localizaÊ não vende dados pessoais. O compartilhamento poderá ocorrer apenas:
                    </p>

                    <p>
                    Com parceiros e fornecedores essenciais à operação da plataforma, mediante contratos de confidencialidade
                    </p>
                    <p>
                    Para cumprimento de obrigações legais, regulatórias ou ordens judiciais
                    </p>
                    <p>
                    Em processos de reorganização societária, fusão ou aquisição, respeitando a legislação aplicável
                    </p>

                    <h2>5. Armazenamento e segurança dos dados</h2>

                    <p>
                    Adotamos medidas técnicas e organizacionais adequadas para proteger os dados pessoais contra acesso não autorizado, 
                    perda, uso indevido, alteração ou divulgação.
                    </p>

                    <p>
                    Os dados são armazenados apenas pelo tempo necessário para cumprir as finalidades descritas nesta Política, 
                    respeitando prazos legais e regulatórios.
                    </p>

                    <h2>6. Direitos do titular dos dados</h2>

                    <p>
                    Nos termos da Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018), você possui os seguintes direitos:
                    </p>

                    <p>Confirmar a existência de tratamento de dados</p>
                    <p>Acessar seus dados pessoais</p>
                    <p>Corrigir dados incompletos, inexatos ou desatualizados</p>
                    <p>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</p>
                    <p>Revogar o consentimento, quando aplicável</p>
                    <p>Solicitar a portabilidade dos dados</p>

                    <p>
                    As solicitações podem ser feitas por meio do canal de contato informado abaixo.
                    </p>

                    <h2>7. Uso de cookies</h2>

                    <p>
                    Utilizamos cookies para melhorar o desempenho da plataforma, analisar padrões de uso e oferecer uma experiência 
                    mais personalizada. Você pode gerenciar ou desativar os cookies nas configurações do seu navegador.
                    </p>

                    <h2>8. Comunicação e marketing</h2>

                    <p>
                    O envio de comunicações promocionais será realizado apenas com o consentimento do usuário, que poderá ser revogado 
                    a qualquer momento por meio do link de descadastro ou contato direto com a Me localizaÊ.
                    </p>

                    <h2>9. Alterações desta Política</h2>

                    <p>
                    Esta Política de Privacidade poderá ser atualizada periodicamente. Recomendamos a revisão frequente deste documento. 
                    Alterações relevantes serão comunicadas de forma adequada.
                    </p>

                    <h2>10. Canal de contato</h2>

                    <p>
                    Para dúvidas, solicitações ou exercício de direitos relacionados à privacidade e proteção de dados, entre em contato:
                    </p>

                    <p><strong>E-mail:</strong> contato@melocalizae.com.br</p>

                    <p>
                    Ao realizar o cadastro, o usuário declara estar ciente e de acordo com esta Política de Privacidade.
                    </p>
                </div>
                
            </div>
            
        </div>
    )
}